import logo from "../assets/images/logo.png";
import mobileLogo from "../assets/images/logo_black.png";
import tf_s_logo from "../assets/images/tf.png";
import dummyUser from "../assets/images/dummyUser.png";

export const app_logo = logo;
export const profile_small_logo = tf_s_logo
export const dark_color_logo = mobileLogo
export const dummyUserImage = dummyUser

export const skillsArray = [
    'Project Management', 'DevOps', 'Cloud Computing',
    'UX Design', 'UI Design', 'Prototyping', 'User Research', 'Wireframing', 'Visual Design',
    'Interaction Design', 'Design Thinking', 'Responsive Design', 'Accessibility Design',
    'Sketch', 'Adobe XD', 'Figma', 'Collaboration Tools', 'Agile Methodology',
    'HTML/CSS', 'User Testing', 'Branding', 'Creative Problem Solving', 'Design Systems',
    'Communication', 'Risk Management', 'Stakeholder Management', 'Budgeting',
    'Resource Allocation', 'Time Management', 'JIRA', 'Vendor Management',
    'Conflict Resolution', 'Change Management', 'JavaScript', 'TypeScript', 'React', 'Node.js', 'Python', 'Java', 'C++',
    'HTML', 'CSS', 'SQL', 'Machine Learning', 'UI/UX Design', 'Quality Assurance', 'Process Improvement',
    'Documentation', 'Meeting Facilitation', 'Client Management', 'Negotiation',
    'Strategic Planning', 'Financial Analysis', 'Investment Strategies', 'Forecasting',
    'Risk Assessment', 'Data Analysis', 'Financial Modeling', 'Market Research',
    'Tax Planning', 'Regulatory Compliance', 'Portfolio Management', 'Reporting',
    'Financial Reporting', 'Cash Flow Management', 'Client Relations', 'Excel',
    'Accounting Principles', 'Economic Analysis', 'Debt Management', 'Valuation',
    'Product Design', 'User-Centered Design', 'Adobe Creative Suite', 'Collaboration',
    'Agile Development', 'Technical Communication', 'Feedback Integration',
    'Visual Storytelling'
];